import _ from "lodash";
import moment from "moment";
import Kichiri from "./KichiriService";
import UserService from "./UserService";
import toast from "react-hot-toast";

const UtilityService = {
	/**
	 * Simple Timeout promise
	 *
	 * @param {Number} ms
	 * @return {Promise}
	 */
	timeout: function(ms) {
		return new Promise(function(resolve, reject) {
			setTimeout(resolve, ms);
		});
	},

	async submitTicket({ name, description }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.support.create({ name, description }, {}, authToken);

			console.log(response);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	getOrdinal(n) {
		var s = ["th", "st", "nd", "rd"];
		var v = n % 100;
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	},

	/**
	 *
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isNullish: value => _.isNil(value),

	/**
	 *
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isNotNullish: value => !_.isNil(value),

	/**
	 * Get the relative dates for message dividers
	 *
	 * @param {Date} date
	 */
	getRelativeDate(date) {
		let momentDate = moment(date);

		if (momentDate.year() !== moment().year()) {
			return momentDate.format("ddd, MMM Do, YYYY");
		}

		return momentDate.calendar(null, {
			sameDay: "[Today]",
			nextDay: "[Tomorrow]",
			nextWeek: "dddd",
			lastDay: "[Yesterday]",
			lastWeek: "ddd, MMM Do",
			sameElse: "ddd, MMM Do"
		});
	},

	/*
	 * Returns a boolean whether or not container is empty
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isEmpty: value => _.isEmpty(value),

	/**
	 *
	 * @param {object} object
	 * @param {string} path
	 * @returns
	 */
	isPathFoundInObject: (object, path) => _.hasIn(object, path),

	/**
	 *
	 * @param {any} value
	 * @param {any} defaultValue
	 * @returns {any}
	 */
	defaultTo: ({ value, defaultValue }) => _.defaultTo(value, defaultValue),

	/**
	 * @description Safetly derives the property from object otherwise defaults to undefined, similar to ?. chaning operator in newer versions of JS
	 * @param {object} object
	 * @param {string} path
	 * @returns {any}
	 */
	getPropertyFromObject: ({ object, path }) => _.get(object, path),

	/**
	 * @description Create a deep copy of an object
	 * @param {Object} object
	 * @returns {Object}
	 */
	deepCopy: object => _.cloneDeep(object),

	/**
	 * @description Returns a boolean whether or not the text is in email format
	 * @param {object} param
	 * @param {string} param.text
	 * @returns {boolean} true if text is in email format
	 */
	isTextInEmailFormat: ({ text }) => {
		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailPattern.test(text);
	},

	/**
	 * Validates the budget format to ensure it follows the "1h 30m" or "1h" or "30m" pattern.
	 *
	 * @param {string} budget - The budget string to validate.
	 * @returns {boolean} - Returns true if the format is valid, otherwise false.
	 */
	validateBudgetFormat: budget => {
		return budget.split(" ").every(part => {
			const num = parseInt(part);
			return (part.endsWith("h") && !isNaN(num)) || (part.endsWith("m") && !isNaN(num));
		});
	},

	/**
	 * @description Replacer function for notes/references
	 * @param {boolean} capitalizeFirstLetter - Flag to capitalize the first letter of the note type.
	 * @param {string} type - The type of note, either "reference" or "note".
	 * @returns {string} - The formatted note type, potentially capitalized.
	 */
	getNoteType: ({ capitalizeFirstLetter, type }) => {
		let typeToReturn = type === "reference" ? "reference" : "note";
		// Capitalize if 'capitalizeFirstLetter' flag is set to true
		return capitalizeFirstLetter ? typeToReturn.charAt(0).toUpperCase() + typeToReturn.slice(1) : typeToReturn;
	},

	/**
	 * Displays an alert with the specified type, message, and configuration.
	 *
	 * @param {Object} options - Configuration options for the alert.
	 * @param {string} options.type - The type of alert (e.g., "success", "error", "info", "warning").
	 * @param {string} options.text - The message to display in the alert.
	 * @param {string} [options.id] - A unique identifier for the alert (optional).
	 * @param {number} [options.timeout] - The time in milliseconds before the alert automatically dismisses (optional).
	 *
	 * @returns {void}
	 */
	alert: ({ type, text, id, timeout }) => {
		try {
			if (type === "dismiss" && id) {
				return toast.dismiss(id);
			}

			if (type === "info") {
				// Custom 'info' toast styling and icon
				return toast(text, {
					icon: "ℹ️",
					style: {
						background: "#fff", // white background
						color: "var(--primary-color)", // primary text color
						fontWeight: 700
					}
				});
			}

			// Handle success, error, or other types
			return toast[type](text, { timeout });
		} catch (error) {
			console.error(error);
		}
	},

	/**
	 * Validates the budget format to ensure it follows the "1h 30m" or "1h" or "30m" pattern.
	 *
	 * @param {string} budget - The budget string to validate.
	 * @returns {boolean} - Returns true if the format is valid, otherwise false.
	 */
	validateBudgetFormat: budget => {
		return budget.split(" ").every(part => {
			const num = parseInt(part);
			return (part.endsWith("h") && !isNaN(num)) || (part.endsWith("m") && !isNaN(num));
		});
	},

	/**
	 * @description Replacer function for notes/references
	 * @param {boolean} capitalizeFirstLetter - Flag to capitalize the first letter of the note type.
	 * @param {string} type - The type of note, either "reference" or "note".
	 * @returns {string} - The formatted note type, potentially capitalized.
	 */
	getNoteType: ({ capitalizeFirstLetter, type }) => {
		let typeToReturn = type === "reference" ? "reference" : "note";
		// Capitalize if 'capitalizeFirstLetter' flag is set to true
		return capitalizeFirstLetter ? typeToReturn.charAt(0).toUpperCase() + typeToReturn.slice(1) : typeToReturn;
	},

	/**
	 * Displays an alert with the specified type, message, and configuration.
	 *
	 * @param {Object} options - Configuration options for the alert.
	 * @param {string} options.type - The type of alert (e.g., "success", "error", "info", "warning").
	 * @param {string} options.text - The message to display in the alert.
	 * @param {string} [options.id] - A unique identifier for the alert (optional).
	 * @param {number} [options.timeout] - The time in milliseconds before the alert automatically dismisses (optional).
	 *
	 * @returns {void}
	 */
	alert: ({ type, text, id, timeout }) => {
		try {
			if (type === "dismiss" && id) {
				return toast.dismiss(id);
			}

			if (type === "info") {
				// Custom 'info' toast styling and icon
				return toast(text, {
					icon: "ℹ️",
					style: {
						background: "#fff", // white background
						color: "var(--primary-color)", // primary text color
						fontWeight: 700
					}
				});
			}

			// Handle success, error, or other types
			return toast[type](text, { timeout });
		} catch (error) {
			console.error(error);
		}
	},

	/**
	 * Initiates a download of a file represented by a blob.
	 *
	 * This function creates a temporary anchor (`<a>`) element, sets its `href` attribute to an object URL representing the blob,
	 * and sets the `download` attribute to the provided filename. It then programmatically clicks the anchor to trigger the download.
	 * After the download is initiated, the function cleans up by removing the anchor from the document and revoking the object URL to release memory.
	 *
	 * @param {Object} params - The parameters object.
	 * @param {Blob} params.blob - The blob representing the file to be downloaded.
	 * @param {string} params.fileName - The name of the file to be downloaded.
	 */
	downloadFile({ blob, fileName }) {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");

		a.href = url;
		a.target = "_blank";
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		a.remove();

		// Clean up the URL object
		window.URL.revokeObjectURL(url);
	},
	isNotAllowedResource : ({response}) => {
		if (response &&  response.error && response.error.code === 403) {
			return true;
		}
		return false;
	},
	/**
	 * Converts any supported date-like input into a **date-only** string in `YYYY-MM-DD` format.
	 *
	 * Why this exists:
	 * - Normalizes dates across the app so APIs / filters / UI comparisons don’t get thrown off by time zones or time parts.
	 *
	 * What it accepts:
	 * - `null` / `undefined` / empty → returns `null`
	 * - A string already in `YYYY-MM-DD` → returns it unchanged (strict validation)
	 * - Anything Moment can parse (Date object, ISO string, etc.) → returns the date portion as `YYYY-MM-DD`
	 *
	 * Safety behavior:
	 * - If the value cannot be parsed into a valid date, returns `null` (instead of throwing).
	 *
	 * @param {any} params.value - Date-like value (string/Date/etc.)
	 * @returns {string|null} Date-only string in `YYYY-MM-DD`, or null if invalid.
	 */
	toDateOnly: ({value}) => {
		if (!value) return null;

		// If it's already "YYYY-MM-DD", keep it exactly (strict parse)
		if (typeof value === "string") {
			const strict = moment(value, "YYYY-MM-DD", true);
			if (strict.isValid()) return strict.format("YYYY-MM-DD");
		}

		// Otherwise, try normal moment parsing (handles Date objects, other strings, etc.)
		const parsed = moment(value);
		if (!parsed.isValid()) return null;

		return parsed.format("YYYY-MM-DD");
	},

	/**
	 * Creates reusable table column resizer that persist widths.
	 *
	 * Creates resize handlers on table columns, and allows resizing between minimum and maximum provided width
	 * @param {Object} params
	 * @param {Function} params.getDefaultColumnWidths
	 * @param {Function} params.getColumnStorageKey
	 * @param {number} [params.minWidth=80]
	 * @param {number} [params.maxWidth=900]
	 * @param {string} [params.cellSelector=".t__row__item"]
	 * @param {string} [params.truncatedClassName="t__row__item--truncated"]
	 * @param {string} [params.scrollableContainerSelector=".scrollable-container"]
	 * @param {string} [params.topScrollbarContentSelector=".scrollable-container__top__content"]
	 */
	createResizableTableColumns: ({
		getDefaultColumnWidths,
		getColumnStorageKey,
		onColumnWidthsChange,
		minWidth = 80,
		maxWidth = 900,
		cellSelector = ".t__row__item",
		truncatedClassName = "t__row__item--truncated",
		scrollableContainerSelector = ".scrollable-container",
		topScrollbarContentSelector = ".scrollable-container__top__content",
	}) => {
		let tableElement = null;
		let activeResize = null;
		let resizeRaf = null;
		let lastWidths = null;
		let didResize = false;
		let suppressClickUntil = 0;
		const resizeDragThreshold = 3;

		// for suppressing accidental clicking on the columns header filters
		const suppressResizeClick = (event) => {
			if (Date.now() < suppressClickUntil) {
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") {
					event.stopImmediatePropagation();
				}
			}
		};

		const getSavedColumnWidths = () => {
			try {
				const key = getColumnStorageKey();
				if (!key) {
					return null;
				}

				return JSON.parse(localStorage.getItem(key) || "null");
			} catch (error) {
				return null;
			}
		};

		const saveColumnWidths = (widths) => {
			try {
				const key = getColumnStorageKey();
				if (!key) {
					return;
				}

				localStorage.setItem(key, JSON.stringify(widths));
			} catch (error) {
				// Ignore 
			}
		};

		const getColStyle = (colId) => ({
			width: `var(--col-${colId}-w)`, //produces: width: var(--col-name-w)
		});

		const applyColumnWidths = (widths) => {
			if (!tableElement) {
				return;
			}
			
			const finalWidths = { ...getDefaultColumnWidths(), ...(widths || {}) };

			lastWidths = finalWidths; 

			//produce: (--col-[colname]-w: [width]px) for each column
			for (const [colId, width] of Object.entries(finalWidths)) {
				tableElement.style.setProperty(`--col-${colId}-w`, `${width}px`);
			}
		};

		const setColumnWidths = (widths) => { 
			applyColumnWidths(widths);
			saveColumnWidths(widths || {});
			requestAnimationFrame(() => {
				checkTruncation();
				syncTopScrollbar();
			});
		};

		const checkTruncation = () => {
			if (!tableElement) {
				return;
			}

			const items = tableElement.querySelectorAll(cellSelector);
			const len = items.length;
			const truncated = new Array(len);

			for (let i = 0; i < len; i++) {
				truncated[i] = items[i].scrollWidth > items[i].clientWidth;
			}

			for (let i = 0; i < len; i++) {
				const item = items[i];
				const shouldHaveClass = truncated[i];
				const hasClass = item.classList.contains(truncatedClassName);

				if (hasClass !== shouldHaveClass) {
					item.classList.toggle(truncatedClassName, shouldHaveClass);
				}
			}
		};

		// explicitly sync the scrollbar above the engagements table
		const syncTopScrollbar = () => {
			if (!tableElement) {
				return;
			}

			const topContent = tableElement
				.closest(scrollableContainerSelector)
				?.querySelector(topScrollbarContentSelector);

			if (topContent) {
				topContent.style.width = `${tableElement.scrollWidth}px`;
			}
		};

		const refreshLayout = () => {
			requestAnimationFrame(() => {
				checkTruncation();
				syncTopScrollbar();
			});
		};

		const stopResizeInteraction = () => {
			window.removeEventListener("pointermove", onResizeMove);
			window.removeEventListener("pointerup", onResizeEnd);
			window.removeEventListener("pointercancel", onResizeEnd);

			document.body.classList.remove("col-resizing");

			if (resizeRaf) {
				cancelAnimationFrame(resizeRaf);
				resizeRaf = null;
			}
		};

		const onResizeStart = (event) => {
			event.preventDefault();
			event.stopPropagation();

			const { colId } = event.currentTarget.dataset;
			if (!tableElement || !colId) {
				return;
			}

			const varName = `--col-${colId}-w`;
			const current = getComputedStyle(tableElement).getPropertyValue(varName).trim();
			const startWidth = Number(current.replace("px", "")) || event.currentTarget.parentElement.offsetWidth;

			activeResize = {
				colId,
				varName,
				startX: event.clientX,
				startWidth,
			};
			didResize = false;

			document.body.classList.add("col-resizing");

			if (event.currentTarget.setPointerCapture && typeof event.pointerId === "number") {
				event.currentTarget.setPointerCapture(event.pointerId);
			}

			window.addEventListener("pointermove", onResizeMove);
			window.addEventListener("pointerup", onResizeEnd);
			window.addEventListener("pointercancel", onResizeEnd);
		};
		
		const onResizeMove = (event) => {
			if (!activeResize || !tableElement) {
				return;
			}

			const { varName, startX, startWidth } = activeResize;
			const delta = event.clientX - startX;
			const nextWidth = _.clamp(startWidth + delta, minWidth, maxWidth);

			if (Math.abs(delta) > resizeDragThreshold) {
				didResize = true;
			}

			if (resizeRaf) {
				return;
			}

			// update the column widths and scrollbar once per animation frame to avoid slow resizing
			resizeRaf = requestAnimationFrame(() => {
				
				//set css variable like: varName = "--col-name-w"
				tableElement.style.setProperty(varName, `${nextWidth}px`); 
				syncTopScrollbar();
				resizeRaf = null;

			});
		};

		const onResizeEnd = () => {
			const resize = activeResize;
			if (!resize) {
				return;
			}

			if (resizeRaf) {
				cancelAnimationFrame(resizeRaf);
				resizeRaf = null;
			}

			stopResizeInteraction();

			const { colId, varName } = resize;
			const finalWidth = parseFloat(getComputedStyle(tableElement).getPropertyValue(varName)) || 0;

			const saved = getSavedColumnWidths() || {};
			const nextWidths = { ...saved, [colId]: finalWidth };
			
			lastWidths = { ...(lastWidths || {}), [colId]: finalWidth };
			saveColumnWidths(nextWidths);

			onColumnWidthsChange(nextWidths);
			if (didResize) {
				suppressClickUntil = Date.now() + 250;
			}

			activeResize = null;
			didResize = false;
			refreshLayout();
		};

		const setTableElement = (element) => {
			if (!element) {
				cleanup();
				return;
			}

			document.addEventListener("click", suppressResizeClick, true);
			tableElement = element;
			applyColumnWidths(getSavedColumnWidths());
			refreshLayout();
		};

		const cleanup = () => {
			stopResizeInteraction();
			activeResize = null;
			didResize = false;
			suppressClickUntil = 0;
			tableElement = null;
			document.removeEventListener("click", suppressResizeClick, true);
		};

		return {
			setTableElement,
			getColStyle,
			checkTruncation,
			syncTopScrollbar,
			refreshLayout,
			onResizeStart,
			onResizeMove,
			onResizeEnd,
			cleanup,
			setColumnWidths,
		};
	},
};

export default UtilityService;
